export default __webpack_public_path__ + "static/media/06_AnimateHalfVertical.8c907edc.mp4";